/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input, OnDestroy, Self } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { filter$, map$, startWith$ } from '@gh/rx/operators';
import { Subscription } from 'rxjs';
import { ContactMenuComponent } from './contact-menu.component';

@Directive({
  selector: '[ghContactMenuControl]',
})
export class ContactMenuControlDirective implements OnDestroy {
  private _control: AbstractControl;
  private valueSubscription?: Subscription;
  private statusSubscription?: Subscription;

  @Input('ghContactMenuControl')
  set control(control: AbstractControl) {
    this._control = control;
    this.unlisten();
    this.listen();
  }

  constructor(@Self() private contactMenu: ContactMenuComponent) {

  }

  ngOnDestroy(): void {
    this.unlisten();
  }

  private listen(): void {
    this.valueSubscription = this._control.valueChanges.pipe(
      startWith$(this._control.value),
      filter$((value) => this.contactMenu.value !== value))
      .subscribe((value) => {
        this.contactMenu.value = value;
        this.contactMenu._markForCheck();
      });

    this.statusSubscription = this._control.statusChanges.pipe(
      startWith$(this._control.status),
      map$((status) => status === 'DISABLED'),
      filter$((disabled) => this.contactMenu.disabled !== disabled))
      .subscribe((disabled) => {
        this.contactMenu.disabled = disabled;
        this.contactMenu._markForCheck();
      });
  }

  private unlisten(): void {
    const { valueSubscription, statusSubscription } = this;

    if (valueSubscription) {
      valueSubscription.unsubscribe();
    }

    if (statusSubscription) {
      statusSubscription.unsubscribe();
    }
  }
}
